import { create } from 'zustand';

/**
 * Tiny shared state for the global command palette so the header trigger
 * button (`HeaderSearchTrigger`) and the palette itself (`CommandPalette`)
 * can stay in two different parts of the tree without prop-drilling.
 *
 * The palette also listens for ⌘K via `useCommandPaletteHotkey` — both paths
 * funnel through `setOpen`.
 */
interface CommandPaletteState {
  open: boolean;
  setOpen: (open: boolean) => void;
  toggle: () => void;
}

export const useCommandPaletteStore = create<CommandPaletteState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
  toggle: () => set((s) => ({ open: !s.open })),
}));
